<template>
  <div class="add-field__values-row">
    <div
      class="add-field__values-input-container"
      :class="{ focus: inputFocus }"
      @click="focusOnInput"
      v-closable="removeFocusInput"
    >
      <div v-if="values.length === 0 && !isInputFocused && inputValue.length === 0" class="add-field__valus-placeholer">
        {{ $t('evaluation-grid.add-field.add-value') }}
      </div>
      <div v-for="(value, index) in values" :key="index">
        <BaseValueTag :value="value" isClearable @delete="deleteValue"> </BaseValueTag>
      </div>
      <input
        class="add-field__values-input"
        @keydown="growToFit"
        @keydown.enter="inputCustomText"
        ref="customText"
        v-model="inputValue"
      />
    </div>
    <BaseButton has-icon-left @click.native="inputCustomText" class="add-field__add-value-btn">
      <BaseIcon name="plus" />
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import BaseValueTag from '@/components/base/BaseValueTag.vue';

export default {
  name: 'BaseMultiTagCreation',
  components: {
    BaseButton,
    BaseIcon,
    BaseValueTag,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputFocus: false,
      inputValue: '',
    };
  },
  computed: {
    isInputFocused() {
      return this.inputFocus;
    },
  },
  methods: {
    // Widen the input as the user types. A Vue handler, not an inline
    // onkeydown attribute: the desktop app's Content-Security-Policy blocks
    // inline event handlers.
    growToFit(event) {
      event.target.style.width = `${event.target.value.length + 1}ch`;
    },
    focusOnInput() {
      const el = this.$refs.customText;
      if (el) el.focus();
      this.inputFocus = true;
    },
    removeFocusInput() {
      this.inputFocus = false;
    },
    inputCustomText() {
      if (this.inputValue.trim().length <= 0) return;

      this.values.push({ value: this.inputValue });
      this.inputValue = '';
      this.$refs.customText.style = 'width: 1px;';

      this.$emit('values-changed', this.values);
    },
    deleteValue(value) {
      const index = this.values.findIndex((obj) => obj.value === value.value || obj === value);
      if (index !== -1) {
        this.values.splice(index, 1);
        this.$emit('values-changed', this.values);
      }
    },
  },
  watch: {},
  created() {},
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
